<template>
  <div>
    <uploaderImage />
  </div>
</template>
<script>
import uploaderImage from '@/components/upload/uploader-image'
export default {
  components: {
    uploaderImage,
  },
}
</script>
